require("./extantCostDetails.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");
const Immutable = require("immutable");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerDataItem = require("components/commons/brokerDataItem/brokerDataItem");
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

// @helpers
const { getFormattedString,
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require("utilities/currencyHelper");

// @constants
const {
  POTENTIAL_SELL_FUNDS_COSTS,
  POTENTIAL_COST,
  POTENTIAL_COST_TYPE,
} = require('constants/index');

class ExtantCostDetails extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildLeftColumn = this.buildLeftColumn.bind(this);
        this.buildRightColumn = this.buildRightColumn.bind(this);
        this.buildContributionAmountItem = this.buildContributionAmountItem.bind(this);
    }

    buildContributionAmountItem = () => {
        const { immInvestmentFunds, immInvestmentFundsWithContribution, immFlagBasedFeatures, immAccount } = this.props;
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
        const skipContribution = immInvestmentFundsWithContribution.get('skipContribution');
        const isSubscription = immInvestmentFunds.getIn(['steps', 0 ,'isSubscription'], false);
        if (ffContribution && !skipContribution && immInvestmentFundsWithContribution && !isSubscription) {
            const contributionAmountObject = Immutable.Map().merge({
                amount: immInvestmentFunds.getIn(['steps', 1, 'amount']),
                currency: immAccount.getIn(['balance', 'currency']),
            });
            const contributionAmount = getFormattedString(contributionAmountObject);
            const periodicityValue = immInvestmentFunds.getIn(['steps', 1, 'periodicityValue']);
            const periodicityOptions = immInvestmentFunds.getIn(['steps', 1, 'periodicityOptions']);
            const periodicityLabelKey = periodicityOptions && periodicityOptions
                .find(option => option.get('value') === periodicityValue)
                .get('label');
            const periodicityLabel = formatText(periodicityLabelKey);

            return (
                <div>
                    <BrokerDataItem
                        label="brokerHireInvestmentStep2-extantCost_contribution"
                        data={`${contributionAmount} ${periodicityLabel}`}
                    />
                </div>
            );
            
        } else null;
    };

    buildLeftColumn() {
        const { immInvestmentFunds, immAccount } = this.props;
        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const currencyObject = Immutable.Map().merge({
            amount: immInvestmentFunds.getIn(["steps", 0, "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        });
        const amountInvestment = getFormattedString(currencyObject);
        const contractNumber = immAccount.get("contractNumber");
        const owner = immAccount.get("accountHolder") || "";
        const accountBalanceObject = Immutable.Map().merge({
            amount: immAccount.getIn(["balance", "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        })
        const accountBalance = getFormattedString(accountBalanceObject);
        const accountLabel = `${immAccount.get(
            "alias"
        )} ...${contractNumber.substring(
            contractNumber.length - 4
        )} (saldo: ${accountBalance})`;

        const contributionItem = this.buildContributionAmountItem();

        return (
            <div className="hire-investment-description__left-column-container">
                <div className="hire-investment-description__column-title">
                    <FormattedText value="brokerHireInvestmentStep2-orderDataTitle" />
                </div>
                <BrokerDataItem
                    label="brokerHireInvestmentStep2-fundToBuy"
                    data={fundName}
                />
                <BrokerDataItem
                    label="brokerHireInvestmentStep2-estimatedAmount"
                    data={amountInvestment}
                    tooltipTitleKey={`brokerHireInvestmentStep2-estimatedAmountTooltipTitle`}
                    tooltipContentKey={`brokerHireInvestmentStep2-estimatedAmountComplexTooltip`}
                    eventCategory="orden compra fondos/paso 2"
                    eventTag={formatText(
                        "brokerHireInvestmentStep2-orderData_estimatedAmount_eventTag"
                    )}
                    complexTooltip
                />
                <BrokerDataItem
                    label="brokerHireInvestmentStep2-extantCost_contract"
                    data={contractNumber}
                />
                {contributionItem}
                <BrokerDataItem
                    label="brokerHireInvestmentStep2-extantCost_first_holder"
                    data={owner}
                />
                <BrokerDataItem
                    label="brokerHireInvestmentStep2-extantCost_associated_account"
                    data={accountLabel}
                />
            </div>
        );
    }

    buildRightColumn() {
        const { immInvestmentFunds, immInvestmentFundsWithContribution, immFlagBasedFeatures } = this.props;
        const ffContribution = immFlagBasedFeatures.get('wealth_funds_periodic_contributions');
        const skipContribution = immInvestmentFundsWithContribution.get('skipContribution');
        const dataExAnt = immInvestmentFunds.getIn(['fetchDataExt', 'response']);
        let data, potentialSellCosts, potentialSellCostsText, recurringTransferCosts;
        if (immInvestmentFunds.get('fetchingDataExt')) {
            data = <LoadingSection />;
        } else if (dataExAnt) {
            data = dataExAnt.map((item, index) => (
                item.get('type')  !== POTENTIAL_COST &&
                (
                    <BrokerExAntSection
                        context="brokerHireInvestmentStep2"
                        eventCategory="orden compra fondos/paso 2"
                        section={item}
                        key={index}
                        complexTooltip={true}
                    />
                )
            ));

            potentialSellCosts  = dataExAnt.find(
                (item) => item.get('type') === POTENTIAL_COST
            );

            recurringTransferCosts = dataExAnt.find(
                (item) => item.get('descriptionKey') === 'recurringTransferCosts'
            );

        } else if (immInvestmentFunds.get('isFetchedPre') === false) {
            data = <LoadingSection />
        }

        if (potentialSellCosts && potentialSellCosts.get('type') === POTENTIAL_COST) {
            const dataPotentialCosts = potentialSellCosts.get('details').toJS()[0];
            const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
            const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
            const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
            const formatAmount = `${amount} ${currency}`
            const tooltipIcon = __CONTACT_CENTER__ ? ccIcon : privateIcon;
            const tooltipTarget = (<img className="broker-ex-ant-cost__item-tooltip" src={tooltipIcon}></img>);
            const tooltip = potentialSellCosts.getIn(['total','tooltipKey']) ? (
                <OKTooltip
                    title={formatText('brokerHireInvestmentStep2-exantCost_potentialCostTooltip_title')}
                    content={formatText('brokerHireInvestmentStep2-exantCost_potentialCostTooltip_content')}
                    placement="top"
                    type={"custom"}
                    target={tooltipTarget}
                    offset={[0, -15]}
                />
            ) : null;

            const text = formatText('brokerHireInvestmentStep2-exantCost_potentialCost_footer', [formatAmount, immPercentage])
            const stylesForText = __CONTACT_CENTER__
              ? 'broker-ex-ant-cost__section-cc'
              : 'broker-ex-ant-cost__section';
            potentialSellCostsText = (
                <div className={stylesForText}>
                    {text} {tooltip}
                </div>
            );
        }

        if(ffContribution && !skipContribution && potentialSellCosts && recurringTransferCosts && immInvestmentFundsWithContribution) {
            const dataPotentialCosts = potentialSellCosts.get('details').toJS()[0];
            const potentialSellCurrency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
            const potentiaSellAmount = formatWithoutRound(dataPotentialCosts.amount, 2);
            const potentialSellPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
            const potentialSellCostAmount = `${potentiaSellAmount} ${potentialSellCurrency}`;
            const periodicityLabel = immInvestmentFundsWithContribution.getIn(['steps','1','periodicityLabel']);
            const amountContribution = immInvestmentFundsWithContribution.getIn(['steps','1','amount']);
            const currencyContribution = immInvestmentFundsWithContribution.getIn(['steps','0','accountAmount','currency']);
            const formatAmountContribution = `${formatWithoutRound(amountContribution, 2)} ${formatCurrency(currencyContribution)}`;
            const amountCost = formatWithoutRound(recurringTransferCosts.getIn(['total', 'amount']), 2);
            const currencyCost = formatCurrency(recurringTransferCosts.getIn(['total', 'currency']));
            const percentageCost = formatPercentage(recurringTransferCosts.getIn(['total', 'percentage']), 2);
            const formatAmountCost = `${amountCost} ${currencyCost} (${percentageCost})`;
            potentialSellCostsText =  (
                <div className="broker-internal-transfer-funds-step2__info-costs">
                    <div>
                        <FormattedText value="brokerHireInvestmentStep2-exantCost_contributionTextOne" injectedStrings={[periodicityLabel, formatAmountCost]} />
                        <FormattedText value="brokerHireInvestmentStep2-exantCost_contributionTextTwo" injectedStrings={[potentialSellCostAmount, potentialSellPercentage]} />
                    </div>
                    <div className="broker-ex-ant-cost__section-total-separator" />
                    <div>
                        <FormattedText value="brokerHireInvestmentStep2-exantCost_contributionTextThree" />

                    </div>
                </div>
            );;

        }


        return (
            <div className="hire-investment-description__right-column-container">
                {data}
                <div>
                    {potentialSellCostsText}
                </div>
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="hire-investment-description__title-description">
                    {title}
                </div>
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                <span className="hire-investment-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immInvestmentFunds } = this.props;
        const dataExAnt = immInvestmentFunds.getIn(['fetchDataExt', 'response']);
        const potentialSellCostFunds  = dataExAnt && dataExAnt.find(
            (item) => item.get("descriptionKey") === POTENTIAL_SELL_FUNDS_COSTS
        );

        return (
            <div className="hire-investment-description__web-wrapper">
                <div className="hire-investment-description__title-description">
                    <FormattedText
                        value="brokerHireInvestmentStep2-description"
                    />
                </div>
                {this.buildLeftColumn()}
                {this.buildRightColumn()}
                {potentialSellCostFunds && potentialSellCostFunds.get('type') === POTENTIAL_COST_TYPE &&
                    <span className="hire-investment-description__footer">
                        <FormattedText
                            value="brokerHireInvestmentStep2-extantCost_footer_description"
                        />
                    </span>
                }
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="hire-investment-description__block-info">
                {this.buildDetails(
                    formatText('brokerHireInvestmentStep2-extantCost_description_cc'),
                    formatText('brokerHireInvestmentStep2-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExtantCostDetails.propTypes = {
    immInvestmentFunds: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immBrokerETFsProduct: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
};

module.exports.constructor = ExtantCostDetails;

export default ExtantCostDetails;
